import $ from "jquery";
export default class ThemeFavIcon {
    static mount() {
        $(function () {
            $(function () {
                if (!window.matchMedia)
                    return;
                var current = $('head > link[rel="icon"][media]');
                $.each(current, function (i, icon) {
                    var iconLink = icon;
                    var match = window.matchMedia(iconLink.media);
                    function swap() {
                        if (match.matches) {
                            current.remove();
                            current = $(icon).appendTo('head');
                        }
                    }
                    match.addEventListener('change', swap);
                    swap();
                });
            });
        });
    }
}
